module.exports = __webpack_public_path__ + "img/File-uploaded.d7819cba.svg";